import { MeetingType, TranscriptFetchStatus } from "../interfaces/DTO/meeting/meeting";

/**
 * Formats a meeting type enum value to a human-readable Hebrew string
 * @param meetingType - The meeting type enum value or number
 * @returns Formatted meeting type label in Hebrew
 */
export function FormatMeetingType(meetingType: MeetingType | number | undefined): string {
  if (meetingType === undefined || meetingType === null) {
    return "לא ידוע";
  }

  switch (meetingType) {
    case MeetingType.SALE:
      return "מכירה";
    case MeetingType.PRE_ADVICE_FIRST:
      return "טרום ייעוץ ראשונה";
    case MeetingType.PRE_ADVICE_SECOND:
      return "טרום ייעוץ שניה";
    case MeetingType.ANNUAL_FOLLOW_UP:
      return "מעקב שנתי";
    case MeetingType.OTHER:
      return "אחר";
    default:
      return "לא ידוע";
  }
}

/**
 * Returns the color associated with a meeting type for UI display
 * @param meetingType - The meeting type enum value or number
 * @returns MUI color variant for Chip component
 */
export function ColorMeetingType(
  meetingType: MeetingType | number | undefined
): "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" {
  if (meetingType === undefined || meetingType === null) {
    return "default";
  }

  switch (meetingType) {
    case MeetingType.SALE:
      return "success";
    case MeetingType.PRE_ADVICE_FIRST:
      return "primary";
    case MeetingType.PRE_ADVICE_SECOND:
      return "secondary";
    case MeetingType.ANNUAL_FOLLOW_UP:
      return "info";
    case MeetingType.OTHER:
      return "warning";
    default:
      return "default";
  }
}

/**
 * Formats a transcript fetch status enum value to a human-readable Hebrew string
 * @param status - The transcript fetch status enum value
 * @returns Formatted status label in Hebrew
 */
export function FormatTranscriptFetchStatus(status: TranscriptFetchStatus | undefined): string {
  if (status === undefined || status === null) {
    return "לא ידוע";
  }

  switch (status) {
    case TranscriptFetchStatus.PENDING:
      return "ממתין";
    case TranscriptFetchStatus.FETCHED:
      return "הושלם";
    case TranscriptFetchStatus.FAILED:
      return "נכשל";
    default:
      return "לא ידוע";
  }
}
